import { internshipOpeningsData, jobOpeningsData } from "../utils/data";
import React, { useState, useEffect } from "react";
import { openRoleData, openRoleDataNew } from "../utils/data";
import NewHead from "./landing/NewHead";
import OpenRoleCards from "./OpenRoleCards";
import { get_job_datas } from "../config/apiCall";
import httpService from "../config/httpCall";
import ServiceFooter from "./ServiceFooter";
import { motion, AnimatePresence } from "framer-motion";
import JobOpenings from "./JobOpenings";

const tabs = [
  { id: "internship", label: "Internship" },
  { id: "job", label: "Job" },
];

const NewCareer = () => {
  const [rolesTab, setRolesTab] = useState("internship");
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [jobdata, setJobdata] = useState([]);

  const handleRoleClick = (tab) => {
    setRolesTab(tab);
  };

  useEffect(() => {
    get_job_data(0);
  }, [0]);

  const get_job_data = async (view) => {
    var data = {
      apiUrl: httpService.get_job_datas,
    };
    var resp = await get_job_datas(data);
    if (resp.status == true) {
      setJobdata(resp.Message.get_job_data);
    } else {
    }
  };

  return (
    <div>
      <NewHead />

      <main className="landingMain about-us pb-1">
        <div className="primary__landing__container">
          <div className="career-container">
            <h1 className="about-us-title">
              Your Next{" "}
              <div className="landing-content-inline">
                <span>Big Step Begins Here.</span>
              </div>
            </h1>
            <p className="about-us-content">
              Join a global community of innovators and shape the future of
              technology.{" "}
              <div className="about-content-inline">
                Explore opportunities across multiple industries and
                disciplines.
              </div>{" "}
            </p>
            <a href="#open-roles">
              <button className="mt-2 career-btn">
                Explore Careers{" "}
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </a>
          </div>

          <div className="about-join-container">
            <div className="row mx-0">
              <div className="col-lg-4">
                <div>
                  <p className="career-join-subcontent">Why join us?</p>
                  <h5 className="career-join-title">
                    Join Us to Impact the{" "}
                    <div className="landing-content-inline">
                      {" "}
                      <span>Future!</span>{" "}
                    </div>{" "}
                  </h5>
                </div>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-7">
                <div className="career-join-content">
                  <p>
                    <span>
                      Beleaf Technologies offers the chance to make a real
                      impact while fostering personal growth in an inclusive
                      environment. With flexible work options and a focus on
                      well-being, we prioritize your work-life balance. Our
                      culture encourages creativity and innovation, empowering
                      you to bring bold ideas to life. Join a global community
                      that’s committed to shaping the future across industries.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="open-roles">
          <div className="primary__landing__container">
            <div className="open-role-wrap">
              <h5 className="open-role-title"> Open Roles</h5>
              <p className="open-role-content">
                Help Us Shape Tomorrow and Discover Your True Place with Us!
              </p>

              <div className="nw_cr_tabs_outer">
                <div className="nw_cr_tabs">
                  <motion.div
                    className="tab-bg"
                    layoutId="tabBackground"
                    transition={{ type: "spring", stiffness: 500, damping: 30 }}
                    style={{
                      width: "50%",
                      left: selectedTab.id === "job" ? "50%" : "0%",
                    }}
                  />
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      className={`nw_cr_tab_btn ${
                        selectedTab.id === tab.id ? "active" : ""
                      }`}
                      onClick={() => setSelectedTab(tab)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="tab_content_wrap">
                <AnimatePresence mode="wait">
                  <motion.h2
                    key={selectedTab.id}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.2 }}
                    className="tab_title"
                  >
                    {selectedTab.id === "internship" ? (
                      <>
                        <div className="open-role-card-wrap">
                          {internshipOpeningsData.map((data) => {
                            return <OpenRoleCards key={data.id} data={data} />;
                          })}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="open-role-card-wrap">
                          {jobdata.map((data) => {
                            return <JobOpenings key={data._id} data={data} />;
                          })}
                        </div>
                      </>
                    )}
                  </motion.h2>
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div className="my-5">
            <div className="float-card-content-wrap">
              <h5 className="floating-title">Life at Beleaf Technologies</h5>
              <p className="floating-content">
                From innovation labs to fun corporate events, discover what it’s
                like to
                <div className="landing-content-inline">
                  <span>be part of a vibrant, global team.</span>
                </div>
              </p>
            </div>

            {/* <div className="primary__landing__container float-card-img-wrap my-5">
              <div className="row floating-card-container">
                <div className="col-sm-6">
                  <img
                    src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752132685/307A8901_e3qpjn.webp"
                    alt="Beleaf Technologies"
                    className="career_float_img"
                  />
                </div>
                <div className="col-sm-6"></div>
              </div>
              <div className="row floating-card-container">
                <div className="col-sm-6"></div>
                <div className="col-sm-6">
                  <img
                    src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752132649/307A8786_uiue2e.webp"
                    alt="Beleaf Technologies"
                    className="career_float_img"
                  />
                </div>
              </div>
              <div className="row floating-card-container">
                <div className="col-sm-6">
                  <img
                    src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746509015/float-card-img-three_n3td62.webp"
                    alt="Beleaf Technologies"
                  />
                </div>
                <div className="col-sm-6"></div>
              </div>
              <div className="row floating-card-container">
                <div className="col-sm-6"></div>
                <div className="col-sm-6">
                  {" "}
                  <img
                    src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746509011/float-card-img-four_xw9lwt.webp"
                    alt="Beleaf Technologies"
                  />
                </div>
              </div>
              <div className="row floating-card-container">
                <div className="col-sm-6">
                  <img
                    src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746509007/float-card-img-five_kmatqn.webp"
                    alt="Beleaf Technologies"
                  />
                </div>
                <div className="col-sm-6"></div>
              </div>
            </div> */}

            <div className="primary__landing__container float-card-img-wrap my-5">
              <div className="row g-sm-5 g-3 mx-0 floating-card-container">
                <div className="col-sm-6">
                  <img
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752132685/307A8901_e3qpjn.webp"
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752474577/cr_one_qmedyg.webp"
                    // src="https://res.cloudinary.com/dr3lpkvua/image/upload/v1762349072/cr_one_qmedyg_ivqu6r.webp"
                    src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1776778747/carrerFrstImg_dvhega.webp"
                    alt="Beleaf Technologies"
                    className="career_float_img"
                    loading="lazy"
                  />
                </div>
                <div className="col-sm-6"></div>

                <div className="col-sm-6"></div>
                <div className="col-sm-6">
                  <img
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752132649/307A8786_uiue2e.webp"
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752474574/cr_two_arpgg3.webp"
                    src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1776778748/carrerScrndImg_ayjhjw.webp"
                    alt="Beleaf Technologies"
                    className="career_float_img cr_flt_img_two"
                    loading="lazy"
                  />
                </div>

                <div className="col-sm-6">
                  <img
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746509015/float-card-img-three_n3td62.webp"
                    src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1776778751/carrerThrdImg_wciyxn.webp"
                    alt="Beleaf Technologies"
                    className="career_float_img"
                    loading="lazy"
                  />
                </div>
                <div className="col-sm-6"></div>

                <div className="col-sm-6"></div>
                <div className="col-sm-6">
                  <img
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752132659/307A8865_fhc8nr.webp"
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752474574/cr_three_kunogh.webp"
                    // src="https://res.cloudinary.com/dr3lpkvua/image/upload/v1762350699/cr_three_kunogh_1_swis1b.webp"
                    src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1776778760/carrerFourthImg_nyr8hp.webp"
                    // src={require("../image/career/cr_three.webp")}
                    alt="Beleaf Technologies"
                    className="career_float_img"
                    loading="lazy"
                  />
                </div>

                <div className="col-sm-6">
                  {" "}
                  <img
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752210757/307A9154_b8whs8.webp"
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752474569/cr_four_hlfjix.webp"
                    src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1776778756/carrerFivethImg_ofl9di.webp"
                    // src={require("../image/career/cr_four.webp")}
                    alt="Beleaf Technologies"
                    className="career_float_img"
                    loading="lazy"
                  />
                </div>
                <div className="col-sm-6"></div>

                <div className="col-sm-6"></div>
                <div className="col-sm-6">
                  <img
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752210801/307A9135_btobns.webp"
                    // src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1752474572/cr_five_pzwf4s.webp"
                    src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1776778754/carrerSixthImg_lgbn1x.webp"
                    // src={require("../image/career/cr_five.webp")}
                    alt="Beleaf Technologies"
                    className="career_float_img"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          What is an Uber clone?
                        </a>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          An Uber clone is a ready-made app solution that
                          replicates the functionalities of Uber, enabling you
                          to launch your own ride-hailing service.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          How much does it cost to develop an Uber clone app?
                        </a>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The cost of an Uber clone app varies based on
                          customization, features, and design requirements, but
                          it is generally more affordable than building from
                          scratch.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          Is the Uber clone app customizable?
                        </a>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, an Uber clone app is fully customizable, allowing
                          you to tailor the design and features to suit your
                          business needs.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq44"
                        >
                          How long does it take to launch an Uber clone app?
                        </a>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The launch time depends on the level of customization,
                          but most Uber clones can be deployed within a few
                          weeks.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          Can I scale the Uber clone app as my business grows?
                        </a>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, the Uber clone app is built for scalability,
                          allowing you to easily grow and expand your services
                          as your business evolves.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article> */}

      <ServiceFooter />
    </div>
  );
};

export default NewCareer;
